// @ts-nocheck
import React, { lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import Loadable from './Loadable';

const Login = Loadable(lazy(() => import('../pages/login')));

export default function Router() {
  return useRoutes([
    {
      path: '*',
      element: <Login />,
    },
  ]);
}
